import React, { useState } from "react";
import styled from "styled-components";

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
`;

const GFieldsStackedInner = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const LabelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const RequiredAsterisk = styled.span`
  color: rgb(223, 63, 63);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  letter-spacing: 2px;
  line-height: 16px;
  text-align: left;
  text-transform: uppercase;
`;

const InputContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
`;

const Field = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  width: 100%;
  box-sizing: border-box;
  padding: 4px 4px 4px 16px;
  height: 42px;
  flex-shrink: 0;
`;

const Placeholder = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  flex: 1;
`;

const SelectButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 8px;
  background: rgb(33, 37, 67);
  color: white;
  padding: 8px 24px;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 125%;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgb(45, 50, 90);
  }
`;

const HelpText = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  color: rgb(100, 116, 139);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  margin-top: 4px;
`;

const FileInput = ({
  label,
  required,
  helpText,
  accept,
  onChange,
  value,
  name,
}) => {
  const [fileName, setFileName] = useState("");
  const fileInputRef = React.useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      if (onChange) {
        onChange(file);
      }
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <GFieldsStacked>
      <GFieldsStackedInner>
        <LabelWrapper>
          <FieldLabel>{label}</FieldLabel>
          {required && <RequiredAsterisk>*</RequiredAsterisk>}
        </LabelWrapper>
        <InputContainer>
          <Field>
            <Placeholder>{fileName || "No file chosen"}</Placeholder>
            <SelectButton onClick={handleButtonClick}>Select file</SelectButton>
          </Field>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            accept={accept}
            name={name}
          />
        </InputContainer>
        {helpText && <HelpText>{helpText}</HelpText>}
      </GFieldsStackedInner>
    </GFieldsStacked>
  );
};

export default FileInput;
